import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DateFormatPipe } from '@iot-platform/pipes';
@Component({
  selector: 'iot-platform-ui-variable-card',
  imports: [FlexLayoutModule, MatIconModule, DateFormatPipe, MatTooltipModule],
  templateUrl: './variable-card.component.html',
  styleUrls: ['./variable-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VariableCardComponent {
  source = input<string>();
  name = input<string>();
  lastValue = input<string>();
  unit = input<string>();
  lastValueTime = input<string>();
}
